import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { Button } from '@/components/v4';
import FormBase from '@/components/forms/new/FormBase';
import CallingRateNameField from './formFields/CallingRateNameField';
import CallingRatePriorityField from './formFields/CallingRatePriorityField';
import CallingRatePrefixField from './formFields/CallingRatePrefixField';
import CallingRateFlagFallInRateField from './formFields/CallingRateFlagFallInRateField';
import CallingRateFlagFallOutRateField from './formFields/CallingRateFlagFallOutRateField';
import CallingRateInboundRateField from './formFields/CallingRateInboundRateField';
import CallingRateOutboundRateField from './formFields/CallingRateOutboundRateField';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import BreadcrumbTrail from 'components/BreadcrumbTrail';

const CallingRatesForm = ({
  mode,
  initialValues,
  isLoading,
  onBack,
  onSubmit,
  onDelete,
  darkMode,
  isDeleting
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
     const breadCrumbTrail = [
          { label: 'Calling Rates', path: ['', { index: 0 }] },
          { label: 'Add Calling Rates', path: '' },
      ];
  return (
    <>
      <>
         <BreadcrumbTrail breadCrumbTrail={breadCrumbTrail} handleBackButton={onBack} />
        <FormBase
          //header={mode === 'edit' ? 'Edit Calling Rate' : 'Add Calling Rate'}
          subTitleHeader={false}
          initialValues={initialValues}
          isLoading={isLoading}
          finalFormSubmit={onSubmit}
          onBack={onBack}
          customClick={true}
          extraButton={
            mode === 'edit' && (
              <Flex justify="flex-end" width="100%">
                <Button
                  w={142}
                  colorScheme="red"
                  onClick={onOpen}
                  isDisabled={isDeleting || isLoading}>
                  Delete
                </Button>
              </Flex>
            )
          }>
        {({ errors, touched }) => [
            <CallingRateNameField key="name" darkMode={darkMode} errors={errors} touched={touched} />,
            <CallingRatePriorityField key="priority" darkMode={darkMode} errors={errors} touched={touched} />,
            <CallingRatePrefixField key="prefix" darkMode={darkMode} errors={errors} touched={touched} />,
            <CallingRateFlagFallInRateField key="flagFallIn" darkMode={darkMode} errors={errors} touched={touched} />,
            <CallingRateFlagFallOutRateField key="flagFallOut" darkMode={darkMode} errors={errors} touched={touched} />,
            <CallingRateInboundRateField key="inbound" darkMode={darkMode} errors={errors} touched={touched} />,
            <CallingRateOutboundRateField key="outbound" darkMode={darkMode} errors={errors} touched={touched} />
        ]}
        </FormBase>
      </>

      <DeleteConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        callingRateName={initialValues?.name}
        onConfirm={() => {
          onDelete();
          onClose();
        }}
        isDeleting={isDeleting}
      />
    </>
  );
};

export default CallingRatesForm;
